import { z } from 'zod';
import { recurrenceFor } from './payments/payments.js';
export const incomeFrequencySchema = z.enum([
    'daily',
    'weekly',
    'biweekly',
    'monthly',
    'quarterly',
    'yearly',
]);
export const INCOME_FREQUENCY_CADENCE = {
    daily: { cadence: 'daily', interval: 1 },
    weekly: { cadence: 'weekly', interval: 1 },
    biweekly: { cadence: 'weekly', interval: 2 },
    monthly: { cadence: 'monthly', interval: 1 },
    quarterly: { cadence: 'monthly', interval: 3 },
    yearly: { cadence: 'yearly', interval: 1 },
};
export function incomeFrequencyRecurrence(frequency, startDate) {
    const { cadence, interval } = INCOME_FREQUENCY_CADENCE[frequency];
    return recurrenceFor(cadence, interval, startDate);
}
//# sourceMappingURL=incomeFrequency.js.map